export default "__VITE_ASSET__BiE8KJVJ__"